module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.hideIfNoRecords || _vm.itemsData.length !== 0) ? _c('div', {
    class: _vm.overrideClass
  }, [(_vm.componentErrorMessage) ? _c('div', {
    staticClass: "error"
  }, [_c('p', [_vm._v(_vm._s(_vm.componentErrorMessage))])]) : _vm._e(), _vm._v(" "), (_vm.search && !_vm.contentOnly) ? _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemsSearchValue),
      expression: "itemsSearchValue"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('generic.overview.search.placeholder')
    },
    domProps: {
      "value": (_vm.itemsSearchValue)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.getSearch()
      }, function($event) {
        _vm.searchOnChange()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemsSearchValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.constructNewOverviewUrl()
    }
  }, [_c('button', {
    staticClass: "search",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.getSearch()
      }
    }
  }, [_c('i', {
    staticClass: "ion-search"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.itemsShowLoading) ? _c('div', [_c('i', {
    staticClass: "ion-loop loading-animation"
  })]) : _c('div', [(!_vm.contentOnly) ? _c('div', {
    staticClass: "row pagination-list"
  }, [(!_vm.itemsError) ? _c('span', [_vm._v(_vm._s(_vm.$t('generic.overview.pagination.pagesize.before')))]) : _vm._e(), _vm._v(" "), (!_vm.itemsError) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paginationPageSize),
      expression: "paginationPageSize"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.paginationPageSize = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handlePaginationPageSize]
    }
  }, _vm._l((_vm.paginationPageSizeOptions), function(option, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.itemsError) ? _c('span', [_vm._v(_vm._s(_vm.$t('generic.overview.pagination.pagesize.after')))]) : _vm._e(), _vm._v(" "), (!_vm.contentOnly) ? _c('div', {
    staticClass: "form-row column__50 text-right"
  }, [(_vm.actions.create.action && _vm.showButtons.create) ? _c('a', {
    staticClass: "link",
    attrs: {
      "icon": "plus",
      "loading": false,
      "title": _vm.actions.create.label,
      "alt": _vm.actions.create.label
    },
    on: {
      "click": _vm.actions.create.action
    }
  }, [_c('i', {
    staticClass: "ion-plus"
  }), _vm._v(" " + _vm._s(_vm.actions.create.label) + "\n        ")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.itemsError) ? _c('div', {
    staticClass: "error--text"
  }, [_vm._v(_vm._s(_vm.overrideError ? _vm.$t(_vm.overrideError) : _vm.itemsError))]) : _c('div', {
    staticClass: "table-scroll"
  }, [_c('table', {
    staticClass: "border",
    class: {
      zebra: _vm.rows.zebra
    }
  }, [_c('thead', [_c('tr', [_vm._l((_vm.columns), function(column, index) {
    return _c('th', {
      key: index,
      style: ({
        textAlign: column.headerAlign
      })
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.sort(column.name)
        }
      }
    }, [_vm._v("\n              " + _vm._s(column.label) + "\n              "), (_vm.isSortField(column.name)) ? _c('i', {
      class: (_vm.getSortDirection() === 'desc' ? 'el-icon-arrow-down' : 'el-icon-arrow-up')
    }) : _vm._e()])])
  }), _vm._v(" "), _c('th', {
    staticClass: "tools"
  }, [_c('a', {
    staticClass: "tools--link"
  }, [(_vm.filterHasToBeDisplayed()) ? _c('i', {
    class: (_vm.isFilterEnabled() ? 'ion-funnel' : 'ion-android-funnel'),
    on: {
      "click": function($event) {
        _vm.startFilterScreen()
      }
    }
  }) : _vm._e()])])], 2), _vm._v(" "), (!_vm.contentOnly) ? _c('td') : _vm._e()]), _vm._v(" "), _c('tbody', _vm._l((_vm.itemsData), function(item, index) {
    return _c('tr', {
      key: index,
      class: {
        canceled: item.canceled
      }
    }, [_vm._l((_vm.columns), function(column, index) {
      return _c('td', {
        key: index,
        class: (column.action ? 'click-cell' : null),
        style: ({
          width: column.width,
          textAlign: column.align
        }),
        on: {
          "click": function($event) {
            ((column.action && column.name !== 'currentValue') ? column.action({
              item: item
            }) : null)
          }
        }
      }, [_vm._v("\n            " + _vm._s(column.processor ? _vm.filter(column.processor(item[column.name]), column.filter, item) : _vm.filter(item[column.name], column.filter, item)) + "\n          ")])
    }), _vm._v(" "), _c('td', {
      staticClass: "tools"
    }, [_vm._l((_vm.itemActions), function(ia) {
      return (!_vm.containsUserRole('dealerview')) ? _c('a', {
        key: ia,
        staticClass: "tools--link",
        on: {
          "click": function($event) {
            ia.perform(item, index)
          }
        }
      }, [_c('i', {
        class: ia.icon
      })]) : _vm._e()
    }), _vm._v(" "), (!_vm.actions.unlock.disable && _vm.actions.unlock.column.identifier && !_vm.contentOnly && _vm.showButtons.unlock && item.locked) ? _c('a', {
      staticClass: "tools--link",
      attrs: {
        "title": _vm.actions.unlock.label,
        "alt": _vm.actions.unlock.label
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.unlockItem(item[_vm.actions.unlock.column.name], item[_vm.actions.unlock.column.identifier])
        }
      }
    }, [_c('i', {
      staticClass: "ion-android-lock"
    })]) : _vm._e(), _vm._v(" "), (!_vm.actions.read.disable && _vm.actions.read.action && !_vm.contentOnly && _vm.showButtons.read && _vm.actions.read.redirectUrl) ? _c('a', {
      staticClass: "tools--link",
      attrs: {
        "title": _vm.actions.read.label,
        "alt": _vm.actions.read.label
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.navigateToDetail(item)
        }
      }
    }, [_c('i', {
      staticClass: "ion-search"
    })]) : _vm._e(), _vm._v(" "), (!_vm.actions.read.disable && _vm.actions.read.action && !_vm.contentOnly && _vm.showButtons.read && !_vm.actions.read.redirectUrl) ? _c('a', {
      staticClass: "tools--link",
      attrs: {
        "title": _vm.actions.read.label,
        "alt": _vm.actions.read.label
      },
      on: {
        "click": function($event) {
          _vm.actions.read.action({
            item: item,
            index: index
          })
        }
      }
    }, [_c('i', {
      staticClass: "ion-search"
    })]) : _vm._e(), _vm._v(" "), (_vm.actions.readsettings && !_vm.actions.readsettings.disable && _vm.actions.readsettings.action && !_vm.contentOnly && _vm.showButtons.readsettings) ? _c('a', {
      staticClass: "tools--link",
      attrs: {
        "title": _vm.actions.readsettings.label,
        "alt": _vm.actions.readsettings.label
      },
      on: {
        "click": function($event) {
          _vm.actions.readsettings.action({
            item: item,
            index: index
          })
        }
      }
    }, [_c('i', {
      staticClass: "ion-clipboard"
    })]) : _vm._e(), _vm._v(" "), (!_vm.actions.update.disable && !_vm.contentOnly && _vm.showButtons.update &&
      _vm.exportSdcWorkflow && _vm.actions.exportWorkflow && item.Version === 2) ? _c('a', {
      staticClass: "tools--link",
      attrs: {
        "title": _vm.actions.exportWorkflow.label,
        "alt": _vm.actions.exportWorkflow.label
      },
      on: {
        "click": function($event) {
          _vm.sdcWorkflowExport(item)
        }
      }
    }, [_c('i', {
      staticClass: "ion-android-download"
    })]) : _vm._e(), _vm._v(" "), (!_vm.actions.update.disable && _vm.actions.update.action && !_vm.contentOnly && _vm.showButtons.update && _vm.actions.read.redirectUrl) ? _c('a', {
      staticClass: "tools--link",
      attrs: {
        "href": _vm.actions.update.redirectUrl({
          item: item
        }),
        "title": _vm.actions.update.label,
        "alt": _vm.actions.update.label
      }
    }, [_c('i', {
      staticClass: "ion-edit"
    })]) : _vm._e(), _vm._v(" "), (_vm.actions.preview && !_vm.actions.preview.disable && _vm.actions.preview.action && !_vm.contentOnly && _vm.showButtons.preview && _vm.actions.preview.redirectUrl) ? _c('a', {
      staticClass: "tools--link",
      attrs: {
        "href": _vm.actions.preview.redirectUrl({
          item: item
        }),
        "title": _vm.actions.preview.label,
        "alt": _vm.actions.preview.label
      }
    }, [_c('i', {
      staticClass: "ion-eye"
    })]) : _vm._e(), _vm._v(" "), (!_vm.actions.update.disable && _vm.actions.update.action && !_vm.contentOnly && _vm.showButtons.update && !_vm.actions.read.redirectUrl) ? _c('a', {
      staticClass: "tools--link",
      attrs: {
        "title": _vm.actions.update.label,
        "alt": _vm.actions.update.label
      },
      on: {
        "click": function($event) {
          _vm.actions.update.action({
            item: item,
            index: index
          })
        }
      }
    }, [_c('i', {
      staticClass: "ion-edit"
    })]) : _vm._e(), _vm._v(" "), (!_vm.actions.delete.disable && _vm.actions.delete.column.identifier && !_vm.contentOnly && _vm.showButtons.delete) ? _c('a', {
      staticClass: "tools--link",
      attrs: {
        "title": _vm.actions.delete.label,
        "alt": _vm.actions.delete.label
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteItem(item, _vm.actions.delete.column)
        }
      }
    }, [_c('i', {
      staticClass: "ion-trash-b"
    })]) : _vm._e()], 2)], 2)
  }), 0)])]), _vm._v(" "), (_vm.filterSection !== 'false' && !_vm.itemsError) ? _c('div', {
    staticClass: "row row--nomargin"
  }, [(_vm.totalText && !_vm.itemsError && !_vm.contentOnly) ? _c('div', {
    staticClass: "form-row items-discovered column__50",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('generic.overview.pagination.showing', {
        current: _vm.paginationCurrentItems,
        total: _vm.itemsTotal
      }))
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-row column__50 text-right"
  }, [(_vm.pagination.items && !_vm.contentOnly) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-size": _vm.pagination.items,
      "layout": "prev, pager, next",
      "total": _vm.itemsTotal,
      "current-page": _vm.itemsParams.page
    },
    on: {
      "current-change": _vm.handlePaginationChange
    }
  })], 1) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('generic.overview.dialog.delete.title'),
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogDeleteVisible),
      callback: function($$v) {
        _vm.dialogDeleteVisible = $$v
      },
      expression: "dialogDeleteVisible"
    }
  }, [(_vm.dialogDeleteUnitList.length > 9) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.$t('generic.overview.dialog.delete.tillDescriptionName')) + "\n        "), _c('span', {
    staticClass: "strong"
  }, [_vm._v(_vm._s(_vm.dialogDeleteName) + " ")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('generic.overview.dialog.delete.tillDescriptionUnit', {
        noUnits: _vm.dialogDeleteUnitList.length,
        units: _vm.dialogDeleteUnitFormatted
      }))
    }
  })])]) : (_vm.dialogDeleteUnitList.length > 0 && _vm.dialogDeleteUnitList.length < 10) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.$t('generic.overview.dialog.delete.tillDescriptionName')) + "\n        "), _c('span', {
    staticClass: "strong"
  }, [_vm._v(_vm._s(_vm.dialogDeleteName) + " ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('generic.overview.dialog.delete.tillDescriptionUnits', {
    noUnits: _vm.dialogDeleteUnitList.length
  })))])])]) : _c('span', [_vm._v("\n      " + _vm._s(_vm.$t('generic.overview.dialog.delete.description')) + " "), _c('span', {
    staticClass: "strong"
  }, [_vm._v(_vm._s(_vm.dialogDeleteName))]), _vm._v("?\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n            " + _vm._s(_vm.$t('generic.overview.dialog.delete.confirmation')) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogDeleteVisible = false, _vm.dialogDeleteIdentifier = '', _vm.dialogDeleteLoading = ''
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.dialogDeleteLoading
    },
    on: {
      "click": _vm.confirmDeleteItem
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.confirm')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('generic.overview.dialog.unlock.title'),
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogUnlockVisible),
      callback: function($$v) {
        _vm.dialogUnlockVisible = $$v
      },
      expression: "dialogUnlockVisible"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('generic.overview.dialog.unlock.description', {
        name: _vm.dialogUnlockName
      }))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n            " + _vm._s(_vm.$t('generic.overview.dialog.unlock.confirmation')) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogUnlockVisible = false, _vm.dialogUnlockIdentifier = '', _vm.dialogUnlockLoading = ''
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.dialogUnlockLoading
    },
    on: {
      "click": _vm.confirmUnlockItem
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.confirm')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('generic.overview.dialog.filter.title'),
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogFilterVisible),
      callback: function($$v) {
        _vm.dialogFilterVisible = $$v
      },
      expression: "dialogFilterVisible"
    }
  }, [(_vm.filterHasToBeDisplayed()) ? _c('span', {
    staticClass: "side--label",
    staticStyle: {
      "color": "#2d4d5a"
    }
  }, [_vm._v(" " + _vm._s(_vm.actions.filter.label))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row__column--50 text-left"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    staticClass: "item-checkbox item-checkbox-inline",
    attrs: {
      "prop": "filter"
    }
  }, [_c('el-checkbox-group', {
    staticClass: "item-checkbox",
    attrs: {
      "loading-text": _vm.loadingText,
      "loading": _vm.loadingFilterData
    },
    on: {
      "change": function($event) {
        _vm.changeFilterSelection()
      }
    },
    model: {
      value: (_vm.form.dialog_filter),
      callback: function($$v) {
        _vm.$set(_vm.form, "dialog_filter", $$v)
      },
      expression: "form.dialog_filter"
    }
  }, _vm._l((_vm.resultFilterDataIncluding), function(item) {
    return _c('tr', {
      key: item
    }, [_c('td', [_c('el-checkbox', {
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(_vm.getFilterLabel(item)))])], 1)])
  }), 0)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "button button--cancel",
    attrs: {
      "native-type": "cancel",
      "title": _vm.$t('generic.overview.buttons.cancel')
    },
    on: {
      "click": function($event) {
        _vm.dialogFilterVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.dialogUnlockLoading
    },
    on: {
      "click": function($event) {
        _vm.filterOverview()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.ok')))])], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7246879d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dq-ui/packages/overview/src/overview.vue
// module id = 509
// module chunks = 36